import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-warning-file-info',
  templateUrl: './custom-sources-warning-file-info.component.html',
  styleUrls: ['./custom-sources-warning-file-info.component.scss']
})
export class CustomSourcesWarningFileInfoComponent {
  @Input() public datasource: DatasetUsageComponentObject;

  public show: boolean = false;

  public onShow(): void {
    this.show = true;
  }

  public onChange(opened: boolean): void {
    this.show = opened;
  }
}
